import {Component, Injector, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Base} from '../pages/base/base';


export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export let type_vehicle = (localStorage.getItem('typeVehicle') == 'motorcycle') ? 'moto' : 'carro';
export const ROUTES: RouteInfo[] = [
  {
    path: '/support',
    title: 'Casos de soporte',
    icon: 'nc-tag-content',
    class: ''
  },
  {
    path: '/documents',
    title: 'Solicitud ' + type_vehicle + 's nuevos',
    icon: 'nc-bus-front-12',
    class: ''
  },
  {
    path: '/changeInformation',
    title: 'Actualización - Documentos  ' + type_vehicle + 's ',
    icon: 'nc-badge',
    class: ''
  },
  {
    path: '/changeInformationLicense',
    title: 'Actualización - Documentos conductor',
    icon: 'nc-single-copy-04',
    class: ''
  },
  {
    path: '/changeInformationVehicle',
    title: 'Solicitud cambio de  ' + type_vehicle + ' ',
    icon: 'nc-bulb-63',
    class: ''
  },
  {
    path: '/notifications',
    title: 'Notificaciones.',
    icon: 'nc-send',
    class: ''
  },
  {
    path: '/news',
    title: 'Noticias y novedades.',
    icon: 'nc-spaceship',
    class: ''
  }
  /*{ path: '/motivations',          title: 'Gestionar motivaciones',   icon:'nc-bullet-list-67',  class: '' },
  { path: '/report',        title: 'Reportes',            icon:'nc-single-copy-04',  class: '' },
  { path: '/file-upload',   title: 'Carga masiva censo',  icon:'nc-cloud-upload-94',  class: '' },*/
    // { path: '/dashboard',     title: 'Dashboard',         icon:'nc-bank',       class: '' },
    // { path: '/icons',         title: 'Icons',             icon:'nc-diamond',    class: '' },
    // { path: '/maps',          title: 'Maps',              icon:'nc-pin-3',      class: '' },
    // { path: '/table',         title: 'Table List',        icon:'nc-tile-56',    class: '' },
    // { path: '/typography',    title: 'Typography',        icon:'nc-caps-small', class: '' },
    // { path: '/upgrade',       title: 'Upgrade to PRO',    icon:'nc-spaceship',  class: 'active-pro' },
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.scss']
})

export class SidebarComponent extends Base {
    public menuItems: any[];

    constructor(inject: Injector, private router: Router) {
      super(inject);
    }

    ngOnInit() {
      this.menuItems = ROUTES.filter(menuItem => menuItem);
    }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  changeInformationVehicle(type) {
    if (localStorage.getItem('typeVehicle') == 'car') {
      this.type_vehicle = 'motorcycle';
      localStorage.setItem('typeVehicle', 'motorcycle')
    } else {
      this.type_vehicle = 'car';
      localStorage.setItem('typeVehicle', 'car')
    }
    window.location.reload();
  }
}
